export const HEADER_AUTHORIZATION = 'Authorization'
export const HEADER_VERIFICATION_TOKEN = 'X-Verification-Token'
export const HEADER_SESSION_ID = 'x-session-id'
